import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="bg-transparent" data-id="element-306" data-mp="2lnc6by59xmw8">
      <div className="w-full" data-id="element-307" data-mp="2lm0t77pxv2sg">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="w-full" data-id="element-308" data-mp="2lpevkfylrbzw">
          <img src="https://cdn.magicpatterns.com/uploads/g3tCJL5uB5fFzbb3qxWCbd/ChatGPT_Image_7_ago_2026,_16_30_49.webp" alt="Muchas personas aprenden Tarot, pero muy pocas aprenden a interpretarlo" className="w-full h-auto block brightness-[1.05] contrast-[1.15] saturate-[1.1]" data-id="element-309" data-mp="2bv65dyx1nv4w" />
        </motion.div>
      </div>
    </section>;
}